import { render, staticRenderFns } from "./TransactionsRecord.vue?vue&type=template&id=385ad148&"
import script from "./TransactionsRecord.vue?vue&type=script&lang=js&"
export * from "./TransactionsRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports